
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/data-visualization-and-reporting-services",
      function () {
        return require("private-next-pages/services/data-visualization-and-reporting-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/data-visualization-and-reporting-services"])
      });
    }
  